import React from 'react';
import { ReceiptItemType } from 'types/generatedSchemaTypes';
import { getCorrectBillingItem } from 'utils/commonUtils';
import { chargingTypes, parkingTypes } from 'utils/parkUtils';
import {
  ItemChargingHistoryDisplay,
  ItemParkingHistoryDisplay,
  ItemPermitHistoryDisplay,
} from './HistoryComponents';

type HistoryItemProps = {
  section: any;
  item: any;
  index: number;
};

const HistoryItem: React.FC<HistoryItemProps> = ({ section, item, index }) => {
  if (!section || section.groupIndex === undefined) {
    return null;
  }

  const { groupIndex } = section;
  const correctItems = getCorrectBillingItem(item.items) ?? [];

  if (!Array.isArray(correctItems) || correctItems.length === 0) {
    return null;
  }

  const type = correctItems[0].type as ReceiptItemType;

  if (parkingTypes.includes(type) || type === 'PREPAID') {
    return (
      <ItemParkingHistoryDisplay
        item={item}
        groupIndex={groupIndex}
        index={index}
      />
    );
  } else if (chargingTypes.includes(type)) {
    return (
      <ItemChargingHistoryDisplay
        item={item}
        groupIndex={groupIndex}
        index={index}
      />
    );
  } else {
    return (
      <ItemPermitHistoryDisplay
        item={item}
        groupIndex={groupIndex}
        index={index}
      />
    );
  }
};

export default React.memo(HistoryItem);
